import {
    AlertColor,
    Autocomplete,
    Button,
    CircularProgress,
    Modal,
    TextField,
    Theme,
    Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { globalTheme } from "../../../common/theme";
import createStyles from "@mui/styles/createStyles";
import axios from "axios";
import React, { useImperativeHandle } from "react";
import { Package, ProductListItem, ProductPackageListItem } from "./ProductAccessories";
import { SnackBarMessage, SnackBarMessageProps } from "../../component/SnackBarMessage";
import Title from "../../component/Title";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { GridColumns, GridToolbarContainer } from "@mui/x-data-grid";
import { CustomTablePagination } from "../../component/CustomPagination";
import { Cancel, CheckCircle, Inventory, Search } from "@mui/icons-material";
import { renewToken } from "../../../services/AuthService";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
    })
);

export interface ProductPackageListHandle {
    Initialise: () => void;
}

export interface ProductPackageListProps {
    productPackages: Package[];
    onClose: Function;
}

export const ProductPackageList = React.forwardRef(
    (props: ProductPackageListProps, ref: React.Ref<ProductPackageListHandle>) => {
        const style = { ...useStyles(), ...globalTheme() };

        const [open, setOpen] = React.useState(false);
        const [loading, setLoading] = React.useState<boolean>(false);

        const selectedProducts = React.useRef<ProductListItem[]>([]);
        const [selectedPackage, setSelectedPackage] = React.useState<Package | null>();
        const [gridData, setGridData] = React.useState<ProductPackageListItem[]>([]);
        //Grid columns
        const columns: GridColumns = [
            { field: 'model', headerName: '型式', flex: 4, type: 'string' },
            { field: 'nameJpn', headerName: '製品名', flex: 5, type: 'string' },
            { field: 'productCode', headerName: '商品CD', flex: 2, type: 'string' },
        ];

        const [searchData, setSearchData] = React.useState<any>({
            pageSize: 15,
        });
    
        //Dialogs and snacks
        const [snackSettings, setSnackSettings] =
        React.useState<SnackBarMessageProps>({
            open: false,
            message: "",
            subMessage: "",
            severity: undefined,
            onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
        });

        function showSnackBar(message: string, subMessage: string, colour?: AlertColor) {
        setSnackSettings({
            open: true,
            message: message,
            subMessage: subMessage,
            severity: colour,
            onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
        });
        }

        function CustomToolbar() {
            return (
                <GridToolbarContainer style={{ display: 'flex' }}>
                    <Autocomplete className={style.ModalContentFieldHalfWidth}
                        onChange={(e, selected) => ReloadPackageItems(selected)}
                        options={props.productPackages}
                        getOptionLabel={(option: Package) => option.description}
                        renderOption={(props, option) => {
                            return (
                                <li {...props} key={option.packageID}>
                                    {option.description}
                                </li>
                            );
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label={"Package"}
                            />
                        )}
                        value={selectedPackage}
                    />
                    <div style={{ flexGrow: 1, minWidth: "10px" }}></div>
                    <Button style={{ width: "120px", minWidth: "100px" }}
                        variant="contained" size="small" color="secondary" startIcon={<CheckCircle />} onClick={() => ClosePackageList(false)}>Select</Button>
                    <div style={{ width: "10px", minWidth: "10px" }}></div>
                    <Button style={{ width: "120px", minWidth: "100px" }}
                        variant="contained" size="small" color="secondary" startIcon={<Cancel />} onClick={(e) => ClosePackageList(true)}>Cancel</Button>
                    <div style={{ width: "10px", minWidth: "10px" }}></div>
                </GridToolbarContainer>
            );
        }

        function ReloadPackageItems(selected: Package | null) {
            setLoading(true);

            setSelectedPackage(selected);

            if (!selected)
            {
                setLoading(false);
                setGridData([]);
                return;
            }

            axios.get<ProductPackageListItem[]>('Api/V1/Package/' + selected?.packageID.toString(), {
                headers: {
                    'Content-Encoding': 'gzip'
                }
            })
                .then((result) => {
                    result.data.forEach(i => {
                        i.id = i.productID;
                    });
                    setGridData(result.data)
                    setLoading(false);
                },
                    (error) => {
                        setGridData([]);
                        setLoading(false);
                        console.log(error);
                        showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
                    }
                )
                .catch((error) => {
                    console.log(error);
                    showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
                });
        }

        useImperativeHandle(ref, () => ({
            Initialise() {
                setOpen(true);
                renewToken();
                
                selectedProducts.current = [];
                setSelectedPackage(null);
                setGridData([]);
            },
        }));

        function ClosePackageList(isCancel: boolean) {
            if (isCancel)
            {
                selectedProducts.current = [];
                setOpen(false);
            }
            else    
            {
                if (selectedPackage)
                {
                    setLoading(true);
                    axios.get<ProductListItem[]>('Api/V1/Package/Selected/' + selectedPackage?.packageID.toString(), {
                        headers: {
                          'Content-Encoding': 'gzip'
                        }
                      })
                        .then((result) => {
                          setOpen(false);
                
                          result.data.forEach(i => {
                            i.id = i.productID;
                            i.selected = true;
                          });
                          selectedProducts.current = result.data;
                          setLoading(false);
      
                          props.onClose(isCancel, selectedProducts);
                      },
                          (error) => {
                            selectedProducts.current = [];
                            setLoading(false);
                            console.log(error);
                            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
                          }
                        )
                        .catch((error) => {
                          console.log(error);
                          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
                      });
                }
            }            
        }

        return (
            <div>
                <Modal open={open} onClose={() => ClosePackageList(true)}>
                    <div className={style.ModalMainMedium}>
                        {!loading ? (
                            <div className={style.ModalBody}>
                                <Title pageTitle="PackageList" />

                                <div className={style.ModalHeading}>
                                    <Typography variant="h4">Package List</Typography>
                                </div>

                                <div className={style.ModalContent}>
                                    <div className={style.PageContent} style={{ minHeight: "400px" }}>
                                        <DataGridPro
                                            getRowId={(row) => row.id}
                                            rows={gridData}
                                            columns={columns}
                                            pageSize={searchData.pageSize}
                                            onPageSizeChange={(pageSize) => setSearchData({ ...searchData, pageSize: pageSize })}
                                            pagination
                                            rowsPerPageOptions={[15, 30, 50, 100]}
                                            loading={loading}
                                            checkboxSelection={false}
                                            components={{
                                                Toolbar: CustomToolbar,
                                                Footer: CustomTablePagination
                                            }}
                                            componentsProps={{
                                                footer: { rowsPerPageOptions: [15, 30, 50, 100] }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div style={{ textAlign: "center" }}>
                                <CircularProgress color="primary" />
                            </div>
                        )}
                    </div>
                </Modal>

                <SnackBarMessage {...snackSettings} />
            </div>
        );


    }

);
